import $ from 'jquery';
import {Swiper, Pagination, Navigation, Controller} from 'swiper/js/swiper.esm.js';
Swiper.use([Pagination, Navigation, Controller]);

$('.section--split-slider').each(function () {
    const $slider = $(this);
    const $imageSlider = $slider.find('.swiper-split-image');
    const $contentSlider = $slider.find('.swiper-split-content');

    const imageSliderOptions = {
        loop: true,
    };

    const contentSliderOptions = {
        loop: true,
        autoHeight: true,
    };

    // region Set up navigation
    if ($imageSlider.attr('data-navtype') === 'simple') {
        imageSliderOptions['navigation'] = {
            nextEl: $imageSlider.find('.simple-nav__button--next')[0],
            prevEl: $imageSlider.find('.simple-nav__button--prev')[0],
        }
    }

    if ($contentSlider.attr('data-navtype') === 'stepped') {
        contentSliderOptions['navigation'] = {
            nextEl: $contentSlider.find('.stepped-nav__button--next')[0],
            prevEl: $contentSlider.find('.stepped-nav__button--prev')[0],
        }
        contentSliderOptions['pagination'] = {
            type: 'fraction',
            el: $contentSlider.find('.stepped-nav__pagination')[0],
        }
    }
    // endregion

    const imageSliderInstance = new Swiper($imageSlider[0], imageSliderOptions);
    if ($contentSlider.length) {
        const contentSliderInstance = new Swiper($contentSlider[0], contentSliderOptions);
        imageSliderInstance.controller.control = contentSliderInstance;
        contentSliderInstance.controller.control = imageSliderInstance;
    }
});
